module.exports = __webpack_public_path__ + "images/emoji/vs.adbf9c8678f13fbab4f7.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/vs.png
// module id = bUGz
// module chunks = 24